import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alertNotifications } from 'src/app/modules/notification/notification';
import { ApiService } from 'src/app/Services/api.service';
import { BreadcrumbService } from 'src/app/Services/breadcrumb.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { PROFILE, ProfileState } from 'src/app/State/profile.state';
import { SocketIOService } from 'src/app/Services/socket.io.service';
import { SubService } from 'src/app/Services/sub.service';
import { VehicleLiveTrackService } from 'src/app/store/vehicle/reducer';
import { OrgNotificationStateManagement } from 'src/app/store/notification/reducer';
import { CommonServices } from 'src/app/Services/common.service';


declare const Swal;

@Component({
  selector: 'app-top-menu-header',
  templateUrl: './top-menu-header.component.html',
  styleUrls: ['./top-menu-header.component.css']
})
export class TopMenuHeaderComponent implements OnInit {
  public userRestrictionData: any = {};
  constructor(public storage: StorageService,
    public sub: SubService,
    public api: ApiService,
    public shared: SharedService,
    public swal: SweetAlert,
    public socket: SocketIOService,
    public profile: ProfileState,
    public router: Router, private route: ActivatedRoute,
    private map: MapService,
    private _router: Router,
    private socketStore: VehicleLiveTrackService,
    private routeService: RouteService,
    private menuService: BreadcrumbService,
    private notificationState: OrgNotificationStateManagement,
    private comservice: CommonServices,
  ) {
    this.menu = this.menuService.getMenu();
    this.listenRouting();
    this.token = this.storage.get('token');
    this.getUrl = this.router.url;

    const currentUrl = this.router.routerState.snapshot.url;
    if (currentUrl === '/master/dashboard') {
      if (this.userInfo && this.userInfo['fieldMap']) {
        this.userRestrictionData = this.userInfo['fieldMap'];
      } else {
        this.userType = this.storage.get('userType');
      }
    } else {
      this.userInfo = this.storage.get('userInfo');
      this.orgID = this.storage.get('userInfo').orgID;
      if (this.userInfo && this.userInfo['fieldMap']) {
        this.userRestrictionData = this.userInfo['fieldMap'];
      } else {
        this.userType = this.storage.get('userType');
      }
    }
    // this.userInfo = this.storage.get('userInfo');
    // this.orgID= this.storage.get('userInfo').orgID;
    // if(this.userInfo && this.userInfo['fieldMap']){
    //   this.userRestrictionData=this.userInfo['fieldMap'];
    // }else{
    //   this.userType = this.storage.get('userType');
    // }
  }
  @Output() tiggleSideBar: EventEmitter<any> = new EventEmitter();

  public alertNotifications = alertNotifications;
  public notificationTooltip: boolean = true;
  public isNotificationOpen: boolean = false;

  public currentTab = '';
  token: string;
  avatar: any;
  userInfo: PROFILE = {
    contactNumber: 0,
    designation: '',
    name: '',
    orgID: '',
    primary: 0,
    status: 0,
    userEmail: '',
    userID: '',
    logo: false,
  };
  osrmUrl: any;
  getUrl: string;

  public masterMenu = [
    {
      label: 'Dashboard',
      icon: 'dashboard',
      path: '/master/dashboard',
    },
    {
      label: 'Organization',
      icon: 'corporate_fare',
      path: '/master/organization',
      id: 'empsMasterNavMenuOrganization',
    }];
  public vendorMenu = [{
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/master/dashboard',
    id: 'empsVendorNavMenuDashboard',
  }, {
    label: 'Dashboard',
    icon: 'Org',
    path: '/master/view-org',
    id: 'empsVendorNavMenuViewOrganization',
  }];
  public currentPath = '';
  public tpmDashboardMenu: any = [];
  public availableTopMenus = [{
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/organization/transport-manager/dashboard',
    id: 'empsTMNavMenuDashboard',
    fieldKey: 'dashboard',
  },
  {
    label: 'SOS Panel',
    icon: 'error',
    path: '/organization/transport-manager/sospanel',
    id: 'empsTMNavMenuSosPanel',
    fieldKey: 'sosPanel',
  },
  {
    label: 'Request',
    icon: 'compare_arrows',
    path: '/organization/transport-manager/request',
    id: 'empsTMNavMenuRequest',
    fieldKey: 'request'
  },

  {
    label: 'Route / Rostering',
    icon: 'call_split',
    path: '/organization/transport-manager/rostering',
    id: 'empsTMNavMenuRouteRostering',
    fieldKey: 'route/rostering'
    // path: '/organization/transport-manager/rostering',

  },
  {
    label: 'Reports',
    icon: 'insert_chart_outlined',
    path: '/organization/transport-manager/reports',
    id: 'empsTMNavMenuReports',
    fieldKey: 'reports'
  },
  {
    label: 'Information',
    icon: 'info',
    path: '/organization/transport-manager/information',
    id: 'empsTMNavMenuInformation',
    fieldKey: 'information'
  },
  /* {
    label: 'Campaigns',
    icon: 'mail_outline',
    path: '/organization/transport-manager/campaigns',
  }, */
  {
    label: 'Support Desk',
    icon: 'contact_support',
    path: '/organization/transport-manager/support-desk',
    id: 'empsTMNavMenuSupportDesk',
    fieldKey: 'supportDesk'
  },
  ];

  public notificationMenu = [
    {
      label: 'SOS',
      id: 'menuTabSOS',
      image: '../../../assets/images/dashboard/sos.png',
      count: 0,
      key: 'sos'
    },
    {
      label: 'Overspeed',
      id: 'menuTabOverspeed',
      image: '../../../assets/images/dashboard/speed.png',
      count: 0,
      key: 'overSpeed'
    },
    {
      label: 'Vehicle Info',
      id: 'menuTabVehInfo',
      image: '../../../assets/images/dashboard/vehicleInfo.png',
      count: 0,
      key: 'vehicleInfo'
    },
    {
      label: 'Break Down',
      id: 'menuTabBreakdown',
      image: '../../../assets/images/dashboard/repair-car.png',
      count: 0,
      key: 'breakdown'
    },
    {
      label: 'Requests',
      id: 'menuTabRequests',
      image: '../../../assets/images/dashboard/requests.png',
      count: 0,
      key: 'request'
    },
    {
      label: 'Complaints',
      id: 'menuTabComplaints',
      image: '../../../assets/images/dashboard/complain.png',
      count: 0,
      key: 'complaints'
    },
  ]

  name: string;
  menu: any = [];
  breadcrumbList: Array<any> = [];
  topMenu: { label: string; icon: string; path: string; }[];
  public dot;
  public myMap: any = this.map.retMap();
  public mousePos;
  public shakeIconClass = "";
  public unchecked = false;

  public empsUser: string = '';

  /* Notifications */
  public notificationData = [];
  public selectedMod: string = '';
  public orgID: string = '';

  /* Field Mapping */
  public mappingField = {};

  public userType: string = '';

  public activeNotifyModule: string = 'SOS';
  public dynamicObj: any = {}

  ngOnInit(): void {
    this.getUserData();
    if (this.userInfo && this.userInfo['userType'] && this.userInfo['userType'] != 'maste-admin') {
      this.setUserInfoToStorage();
    } else {
      this.topMenuSetup();
    }
    this.checkNotificationOpen();
  }
  async createTopMenu() {
    this.tpmDashboardMenu = await this.findAvailableTopMenus();
    this.topMenuSetup();
    const url = this.router.url.split('/');
    if (url && url[2] === 'transport-manager') {
      this.navigateToActiveMenu();
    }
  }
  setUserInfoToStorage() {
    const obj = {
      orgID: this.userInfo.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
      let mail = this.userInfo.userEmail;
      let user = res.data['userInfo'].filter(e => e.userEmail == mail);
      this.userInfo['fieldMap'] = user[0]['fieldMap'];
      this.storage.setData({ userInfo: this.userInfo });
      this.createTopMenu();
    }).catch((err) => {
      console.log(err);
    });
  }
  async navigateToActiveMenu() {
    // let activeMenu='';
    const url = this.router.url.split('/');
    let activeModule = '';
    if (url[3] == 'dashboard') {
      activeModule = 'Dashboard';
    } else if (url[3] == 'sospanel') {
      activeModule = 'SOS Panel';
    } else if (url[3] == 'request') {
      activeModule = 'Request';
    } else if (url[3] == 'rostering') {
      activeModule = 'Route / Rostering';
    } else if (url[3] == 'reports') {
      activeModule = 'Reports';
    } else if (url[3] == 'information') {
      activeModule = 'Information';
    } else if (url[3] == 'support-desk') {
      activeModule = 'Support Desk';
    }
    let menus = Object.keys(this.userRestrictionData);
    let activeMenu = [];
    let path = [];
    for (let i = 0; i < menus.length; i++) {
      if (this.userRestrictionData[menus[i]].checked || this.userRestrictionData[menus[i]].indeterminate) {
        if (menus[i] == 'Dashboard') {
          activeMenu.push('dashboard');
          path.push('dashboard');
        } else if (menus[i] == 'SOS Panel') {
          activeMenu.push('sospanel');
          if (activeModule == 'SOS Panel') {
            if (url[4] == 'map-view') {
              path.push('sospanel/map-view');
            } else if (url[4] == 'list-view') {
              path.push('sospanel/list-view');
            }
          } else {
            path.push('sospanel/map-view');
          }
        } else if (menus[i] == 'Request') {
          activeMenu.push('request');
          if (activeModule == 'Request') {
            let url = this.findPath(this.router.url);
            path.push(url);
          } else {
            path.push('request/list-request');
          }
        } else if (menus[i] == 'Route / Rostering') {
          activeMenu.push('rostering');
          if (activeModule == 'Route / Rostering') {
            let activeUrl = this.router.url.split('/');
            let activeRosterModule = '';
            if (activeUrl.length == 4 && activeUrl[3] == 'rostering') {
              activeRosterModule = 'Activities';
            } else if (activeUrl[4] == 'manage-route') {
              activeRosterModule = 'Manage';
            } else {
              if (activeUrl[4] == 'create-route' && activeUrl[5] == 'regular') {
                activeRosterModule = 'Regular';
              } else if (activeUrl[4] == 'create-route' && activeUrl[5] == 'occasional') {
                activeRosterModule = 'Occasional';
              } else if (activeUrl[4] == 'create-route' && activeUrl[5] == 'openBooking') {
                activeRosterModule = 'Open Booking';
              }
            }
            let keys = Object.keys(this.userRestrictionData['Route / Rostering'].menu1);
            let availableModules = [];
            let availablePath = [];
            for (let i = 0; i < keys.length; i++) {
              if (this.userRestrictionData['Route / Rostering'].menu1[keys[i]].checked || this.userRestrictionData['Route / Rostering'].menu1[keys[i]].indeterminate) {
                if (keys[i] == 'Activities') {
                  availablePath.push('rostering');
                } else if (keys[i] == 'Manage') {
                  availablePath.push('rostering/manage-route');
                } else if (keys[i] == 'Regular') {
                  availablePath.push('rostering/create-route/regular');
                } else if (keys[i] == 'Occasional') {
                  availablePath.push('rostering/create-route/occasional');
                } else if (keys[i] == 'Open Booking') {
                  availablePath.push('rostering/create-route/openBooking');
                }
                availableModules.push(keys[i]);
              }
            }
            if (activeRosterModule != '') {
              let modIndex = availableModules.findIndex(e => e == activeRosterModule);
              if (modIndex != -1) {
                let actvSubModUrl = this.router.url.split('/');
                let actvSubMod = '';
                if (actvSubModUrl.includes('configuration')) {
                  actvSubMod = 'Configuration';
                } else if (actvSubModUrl[5] == 'roster') {
                  actvSubMod = 'Roster';
                }
                let subModKeys = Object.keys(this.userRestrictionData['Route / Rostering'].menu1['Manage'].menu2)
                let subModPath = [];
                let avlSubMod = [];
                for (let m = 0; m < subModKeys.length; m++) {
                  if (this.userRestrictionData['Route / Rostering'].menu1['Manage'].menu2[subModKeys[m]].checked || this.userRestrictionData['Route / Rostering'].menu1['Manage'].menu2[subModKeys[m]].indeterminate) {
                    if (subModKeys[m] == 'Configuration') {
                      let conUrl = this.router.url.split('/');
                      if (conUrl.length == 7 && conUrl[5] == 'configuration' && conUrl[6] == 'route-cutoff') {
                        subModPath.push('rostering/manage-route/configuration/route-cutoff');
                      } else {
                        subModPath.push('rostering/manage-route/configuration');
                      }
                    } else if (subModKeys[m] == 'Roster') {
                      subModPath.push('rostering/manage-route/roster');
                    }
                    avlSubMod.push(subModKeys[m]);
                  }
                }
                if (actvSubMod != '' && subModKeys.includes(actvSubMod)) {
                  let subModIndex = avlSubMod.findIndex(e => e == actvSubMod);
                  if (subModIndex != -1) {
                    path.push(subModPath[subModIndex]);
                  } else {
                    path.push('rostering/manage-route');
                  }
                } else {
                  let url = this.findPath(this.router.url);
                  path.push(url);
                }
              } else {
                path.push(availablePath[0]);
              }
            } else {
              let url = this.findPath(this.router.url);
              path.push(url);
            }
          } else {
            path.push('rostering');
          }
        } else if (menus[i] == 'Reports') {
          activeMenu.push('reports');
          if (activeModule == 'Reports') {
            let activeUrl = this.router.url.split('/');
            let activeReportModule = '';
            if (activeUrl[4] == 'report-dashboard') {
              path.push('reports/report-dashboard');
            } else {
              if (activeUrl.length == 5) {
                if (activeUrl[4] == 'sos-reports') {
                  activeReportModule = 'SOS Report';
                } else if (activeUrl[4] == 'overspeed-reports') {
                  activeReportModule = 'Over Speed Report';
                } else if (activeUrl[4] == 'movement-reports') {
                  activeReportModule = 'Movement Report';
                } else if (activeUrl[4] == 'halt-reports') {
                  activeReportModule = 'Halt Report';
                } else if (activeUrl[4] == 'productivity-reports') {
                  activeReportModule = 'Productivity Report on Trip';
                } else if (activeUrl[4] == 'offline-reports') {
                  activeReportModule = 'Offline Report';
                } else if (activeUrl[4] == 'employee-booking-count' || activeUrl[4] == 'employee-booking-reports'
                  || activeUrl[4] == 'excess-employee-report' || activeUrl[4] == 'vehicle-booking-history'
                  || activeUrl[4] == 'route-booking-history') {
                  activeReportModule = 'Employee Booking Reports';
                } else if (activeUrl[4] == 'app-reports') {
                  activeReportModule = 'App Usage Report';
                } else if (activeUrl[4] == 'safe-drop-reports') {
                  activeReportModule = 'Safe Drop Report';
                } else if (activeUrl[4] == 'attendance-reports' || activeUrl[4] == 'security-reports') {
                  activeReportModule = 'Attendance';
                } else if (activeUrl[4] == 'trip-reports') {
                  activeReportModule = 'Trip Report';
                } else if (activeUrl[4] == 'mis-reports') {
                  activeReportModule = 'MIS Report';
                } else if (activeUrl[4] == 'complaint-ratings') {
                  activeReportModule = 'Complaint Ratings';
                } else if (activeUrl[4] == 'head-reports' || activeUrl[4] == 'vehicle-wise' || activeUrl[4] == 'no-show-report') {
                  activeReportModule = 'Head Counts';
                } else if (activeUrl[4] == 'geo-reports') {
                  activeReportModule = 'Geo Entry Exit';
                } else if (activeUrl[4] == 'vehicle-audit-report') {
                  activeReportModule = 'Vehicle Audit Report';
                } else if (activeUrl[4] == 'vehicle-arriving-time') {
                  activeReportModule = 'Vehicle Arriving Time';
                } else if (activeUrl[4] == 'employee-boarding-history') {
                  activeReportModule = 'Employee Boarding History';
                } else if (activeUrl[4] == 'seat-occupancy-report') {
                  activeReportModule = 'Seat Occupancy Report';
                } else if (activeUrl[4] == 'route-violation') {
                  activeReportModule = 'Route Violation';
                } else if (activeUrl[4] == 'gps-failure') {
                  activeReportModule = 'GPS Failure';
                } if (activeUrl[4] == 'towalert-report') {
                  activeReportModule = 'Tow Alert Report';
                } if (activeUrl[4] == 'night-drive-report') {
                  activeReportModule = 'Night Drive Report';
                } if (activeUrl[4] == 'continuous-driving-report') {
                  activeReportModule = 'Continuous Driving Report';
                } if (activeUrl[4] == 'mobile-app-usage-reports') {
                  // activeReportModule = 'Driver App Usage Report';
                  activeReportModule = 'Mobile App Usage Report';
                } if (activeUrl[4] == 'harsh-acceleration-braking') {
                  activeReportModule = 'Harsh Acceleration Braking';
                }
                let keys = Object.keys(this.userRestrictionData['Reports'].menu1);
                keys = keys.filter((item: any) => item != 'Trip Report New')
                let availableModules = [];
                let availablePath = [];
                for (let i = 0; i < keys.length; i++) {
                  if (this.userRestrictionData['Reports'].menu1[keys[i]].checked || this.userRestrictionData['Reports'].menu1[keys[i]].indeterminate) {
                    if (keys[i] == 'SOS Report') {
                      availablePath.push('reports/sos-reports');
                    } else if (keys[i] == 'Over Speed Report') {
                      availablePath.push('reports/overspeed-reports');
                    } else if (keys[i] == 'Movement Report') {
                      availablePath.push('reports/movement-reports');
                    } else if (keys[i] == 'Halt Report') {
                      availablePath.push('reports/halt-reports');
                    } else if (keys[i] == 'Productivity Report on Trip') {
                      availablePath.push('reports/productivity-reports');
                    } else if (keys[i] == 'Offline Report') {
                      availablePath.push('reports/offline-reports');
                    } else if (keys[i] == 'Employee Booking Reports') {
                      let subUrl = this.router.url.split('/');
                      if (subUrl[4] == 'excess-employee-report') {
                        availablePath.push('reports/excess-employee-report');
                      } else if (subUrl[4] == 'vehicle-booking-history') {
                        availablePath.push('reports/vehicle-booking-history');
                      } else if (subUrl[4] == 'route-booking-history') {
                        availablePath.push('reports/route-booking-history');
                      } else if (subUrl[4] == 'employee-booking-count') {
                        availablePath.push('reports/employee-booking-count');
                      } else {
                        availablePath.push('reports/employee-booking-reports');
                      }
                    } else if (keys[i] == 'App Usage Report') {
                      availablePath.push('reports/app-reports');
                    } else if (keys[i] == 'Safe Drop Report') {
                      availablePath.push('reports/safe-drop-reports');
                    } else if (keys[i] == 'Attendance') {
                      let subUrl = this.router.url.split('/');
                      if (subUrl[4] == 'security-reports') {
                        availablePath.push('reports/security-reports');
                      } else {
                        availablePath.push('reports/attendance-reports');
                      }
                    } else if (keys[i] == 'Trip Report') {
                      availablePath.push('reports/trip-reports');
                    }
                    else if (keys[i] == 'MIS Report') {
                      availablePath.push('reports/mis-reports');
                    }
                    else if (keys[i] == 'Complaint Ratings') {
                      availablePath.push('reports/complaint-ratings');
                    } else if (keys[i] == 'Head Counts') {
                      let subUrl = this.router.url.split('/');
                      if (subUrl[4] == 'vehicle-wise') {
                        availablePath.push('reports/vehicle-wise');
                      } else if (subUrl[4] == 'no-show-report') {
                        availablePath.push('reports/no-show-report');
                      } else {
                        availablePath.push('reports/head-reports');
                      }
                    } else if (keys[i] == 'Geo Entry Exit') {
                      availablePath.push('reports/geo-reports');
                    } else if (keys[i] == 'Vehicle Arriving Time') {
                      availablePath.push('reports/vehicle-arriving-time');
                    } else if (keys[i] == 'Employee Boarding History') {
                      availablePath.push('reports/employee-boarding-history');
                    } else if (keys[i] == 'Vehicle Audit Report') {
                      availablePath.push('reports/vehicle-audit-report');
                    } else if (keys[i] == 'Seat Occupancy Report') {
                      availablePath.push('reports/seat-occupancy-report');
                    } else if (keys[i] == 'Route Violation') {
                      availablePath.push('reports/route-violation');
                    } else if (keys[i] == 'GPS Failure') {
                      availablePath.push('reports/gps-failure');
                    } else if (keys[i] == 'Tow Alert Report') {
                      availablePath.push('reports/towalert-report');
                    } else if (keys[i] == 'Night Drive Report') {
                      availablePath.push('reports/night-drive-report');
                    } else if (keys[i] == 'Continuous Driving Report') {
                      availablePath.push('reports/continuous-driving-report');
                      // } if (keys[i] == 'Driver App Usage Report') {
                    } else if (keys[i] == 'Mobile App Usage Report') {
                      availablePath.push('reports/mobile-app-usage-reports');
                    } else if (keys[i] == 'Harsh Acceleration Braking') {
                      availablePath.push('reports/harsh-acceleration-braking');
                    }
                    availableModules.push(keys[i]);
                  }
                }
                let index = availableModules.findIndex(e => e == activeReportModule);
                if (index != -1) {
                  path.push(availablePath[index]);
                } else {
                  path.push('reports/report-dashboard');
                }
              } else if (activeUrl.length == 6) {
                let subRepMod = '';
                if (activeUrl[4] == 'app-reports' && activeUrl[5] == 'employee') {
                  subRepMod = 'Employee App Report';
                } else if (activeUrl[4] == 'app-reports' && activeUrl[5] == 'driver') {
                  subRepMod = 'Driver App Report';
                } else {
                  let url = this.findPath(this.router.url);
                  path.push(url);
                }
                let keys = Object.keys(this.userRestrictionData['Reports'].menu1);
                let availableModules = [];
                let availablePath = [];
                for (let i = 0; i < keys.length; i++) {
                  if (this.userRestrictionData['Reports'].menu1[keys[i]].checked || this.userRestrictionData['Reports'].menu1[keys[i]].indeterminate) {
                    if (keys[i] == 'App Usage Report') {
                      if (subRepMod == 'Employee App Report') {
                        path.push('reports/app-reports/employee');
                      } else if (subRepMod == 'Driver App Report') {
                        path.push('reports/app-reports/driver');
                      }
                    }
                  } else {
                    path.push('reports/report-dashboard');
                  }
                }
              } else {
                let url = this.findPath(this.router.url);
                path.push(url);
              }
            }

          } else {
            path.push('reports/report-dashboard');
          }
        } else if (menus[i] == 'Information') {
          activeMenu.push('information');
          if (activeModule == 'Information') {
            let infoUrl = this.router.url.split('/');
            let actvInfoModule = '';
            if (infoUrl[3] == 'information' && infoUrl.length == 4) {
              path.push('information');
            } else {
              if (infoUrl[4] == 'vendor') {
                actvInfoModule = 'Transport Vendors';
              } else if (infoUrl[4] == 'orgInfo') {
                actvInfoModule = 'Organization';
              } else if (infoUrl[4] == 'account' && infoUrl[5] == 'profile') {
                actvInfoModule = 'Account';
              }
              // else{
              //   let url=this.findPath(this.router.url);
              //   path.push(url);
              //   return;
              // }
              let keys = Object.keys(this.userRestrictionData['Information'].menu1);
              let availableModules = [];
              let availablePath = [];
              for (let i = 0; i < keys.length; i++) {
                if (this.userRestrictionData['Information'].menu1[keys[i]].checked || this.userRestrictionData['Information'].menu1[keys[i]].indeterminate) {
                  if (keys[i] == 'Transport Vendors') {
                    availablePath.push('information/vendor/view-vendor');
                  } else if (keys[i] == 'Organization') {
                    availablePath.push('information/orgInfo');
                  } else if (keys[i] == 'Account') {
                    availablePath.push('information/account/profile');
                  }
                  availableModules.push(keys[i]);
                }
              }
              if (actvInfoModule != '') {
                let modIndex = availableModules.findIndex(e => e == actvInfoModule);
                if (modIndex != -1) {
                  let actvSubModUrl = this.router.url.split('/');
                  let actvSubMod = '';
                  let id = '';
                  if (actvSubModUrl.length == 8 && actvSubModUrl[7]) {
                    id = actvSubModUrl[7];
                  }
                  if (actvSubModUrl[5] == 'branch' && (actvSubModUrl[6] == 'add-branch' || actvSubModUrl[6] == 'view-branch' || actvSubModUrl[6] == 'edit-branch')) {
                    actvSubMod = 'Branch';
                  } else if (actvSubModUrl[5] == 'shift' && (actvSubModUrl[6] == 'add-shift' || actvSubModUrl[6] == 'list-shift' || actvSubModUrl[6] == 'edit-shift')) {
                    actvSubMod = 'Shift Management';
                  } else if (actvSubModUrl[5] == 'employee' && (actvSubModUrl[6] == 'view-employee' || actvSubModUrl[6] == 'single-view-employee' || actvSubModUrl[6] == 'add-employee' || actvSubModUrl[6] == 'edit-employee')) {
                    actvSubMod = 'Employees';
                  } else if (actvSubModUrl[5] == 'guest' && (actvSubModUrl[6] == 'view-guest' || actvSubModUrl[6] == 'single-view-guest' || actvSubModUrl[6] == 'add-guest' || actvSubModUrl[6] == 'edit-guest')) {
                    actvSubMod = 'Guest';
                  } else if (actvSubModUrl[5] == 'parking' && (actvSubModUrl[6] == 'add-parking' || actvSubModUrl[6] == 'view-parking' || actvSubModUrl[6] == 'edit-parking')) {
                    actvSubMod = 'Parking';
                  } else if (actvSubModUrl[5] == 'notification') {
                    actvSubMod = 'Notifications';
                  } else if (actvSubModUrl[5] == 'holiday') {
                    actvSubMod = 'Holidays';
                  } else if (actvSubModUrl[5] == 'escort' && (actvSubModUrl[6] == 'view-escort' || actvSubModUrl[6] == 'single-view-escort' || actvSubModUrl[6] == 'add-escort' || actvSubModUrl[6] == 'edit-escort')) {
                    actvSubMod = 'Escort';
                  } else if (actvSubModUrl[5] == 'location' && (actvSubModUrl[6] == 'add-location' || actvSubModUrl[6] == 'view-location' || actvSubModUrl[6] == 'edit-location')) {
                    actvSubMod = 'Location';
                  } else if ((actvSubModUrl[5] == 'global-settings' && actvSubModUrl[6] == 'mail-configuration' || (actvSubModUrl[5] == 'global-settings' && actvSubModUrl[6] == 'booking-day-configuration') || (actvSubModUrl[5] == 'global-settings' && actvSubModUrl[6] == 'openbooking-status'))) {
                    actvSubMod = 'Global Settings';
                  } else if (actvSubModUrl[5] == 'users' && (actvSubModUrl[6] == 'add-users' || actvSubModUrl[6] == 'view-users' || actvSubModUrl[6] == 'edit-users')) {
                    actvSubMod = 'Users';
                  } else if (actvSubModUrl[5] == 'geofence' && (actvSubModUrl[6] == 'add-geofence' || actvSubModUrl[6] == 'view-geofence' || actvSubModUrl[6] == 'edit-geofence')) {
                    actvSubMod = 'Geofence';
                  } else if (actvSubModUrl[5] == 'geolocation' && (actvSubModUrl[6] == 'add-geolocation' || actvSubModUrl[6] == 'view-geolocation' || actvSubModUrl[6] == 'edit-geolocation')) {
                    actvSubMod = 'Geo Location';
                  }
                  let subModKeys = Object.keys(this.userRestrictionData['Information'].menu1['Organization'].menu2)
                  let subModPath = [];
                  let avlSubMod = [];
                  for (let m = 0; m < subModKeys.length; m++) {
                    if (this.userRestrictionData['Information'].menu1['Organization'].menu2[subModKeys[m]].checked || this.userRestrictionData['Information'].menu1['Organization'].menu2[subModKeys[m]].indeterminate) {
                      let subUrl = this.router.url.split('/');
                      if (subModKeys[m] == 'Branch') {
                        if (subUrl[5] == 'branch' && subUrl[6] == 'edit-branch') {
                          subModPath.push('information/orgInfo/branch/edit-branch/' + id);
                        } else if (subUrl[5] == 'branch' && subUrl[6] == 'add-branch') {
                          subModPath.push('information/orgInfo/branch/add-branch');
                        } else {
                          subModPath.push('information/orgInfo/branch/view-branch');
                        }
                      } else if (subModKeys[m] == 'Shift Management') {
                        if (subUrl[5] == 'shift' && subUrl[6] == 'edit-shift') {
                          subModPath.push('information/orgInfo/shift/edit-shift/' + id);
                        } else if (subUrl[5] == 'shift' && subUrl[6] == 'add-shift') {
                          subModPath.push('information/orgInfo/shift/add-shift');
                        } else {
                          subModPath.push('information/orgInfo/shift/list-shift');
                        }
                      } else if (subModKeys[m] == 'Employees') {
                        if (subUrl[5] == 'employee' && subUrl[6] == 'single-view-employee') {
                          subModPath.push('information/orgInfo/employee/single-view-employee/' + id);
                        } else if (subUrl[5] == 'employee' && subUrl[6] == 'edit-employee') {
                          subModPath.push('information/orgInfo/employee/edit-employee/' + id);
                        } else if (subUrl[5] == 'employee' && subUrl[6] == 'add-employee') {
                          subModPath.push('information/orgInfo/employee/add-employee');
                        } else {
                          subModPath.push('information/orgInfo/employee/view-employee');
                        }
                      } else if (subModKeys[m] == 'Guest') {
                        if (subUrl[5] == 'guest' && subUrl[6] == 'single-view-guest') {
                          subModPath.push('information/orgInfo/guest/single-view-guest/' + id);
                        } else if (subUrl[5] == 'guest' && subUrl[6] == 'edit-guest') {
                          subModPath.push('information/orgInfo/guest/edit-guest/' + id);
                        } else if (subUrl[5] == 'guest' && subUrl[6] == 'add-guest') {
                          subModPath.push('information/orgInfo/guest/add-guest');
                        } else {
                          subModPath.push('information/orgInfo/guest/view-guest');
                        }
                      } else if (subModKeys[m] == 'Parking') {
                        if (subUrl[5] == 'parking' && subUrl[6] == 'edit-parking') {
                          subModPath.push('information/orgInfo/parking/edit-parking/' + id);
                        } else if (subUrl[5] == 'parking' && subUrl[6] == 'add-parking') {
                          subModPath.push('information/orgInfo/parking/add-parking');
                        } else {
                          subModPath.push('information/orgInfo/parking/view-parking');
                        }
                      } else if (subModKeys[m] == 'Notifications') {
                        subModPath.push('information/orgInfo/notification');
                      } else if (subModKeys[m] == 'Holidays') {
                        subModPath.push('information/orgInfo/holiday');
                      } else if (subModKeys[m] == 'Escort') {
                        if (subUrl[5] == 'escort' && subUrl[6] == 'single-view-escort') {
                          subModPath.push('information/orgInfo/escort/single-view-escort/' + id);
                        } else if (subUrl[5] == 'escort' && subUrl[6] == 'edit-escort') {
                          subModPath.push('information/orgInfo/escort/edit-escort/' + id);
                        } else if (subUrl[5] == 'escort' && subUrl[6] == 'add-escort') {
                          subModPath.push('information/orgInfo/escort/add-escort');
                        } else {
                          subModPath.push('information/orgInfo/escort/view-escort');
                        }
                      } else if (subModKeys[m] == 'Location') {
                        let url = this.findPath(this.router.url);
                        if (subUrl[5] == 'location' && subUrl[6] == 'edit-location') {
                          subModPath.push('information/orgInfo/location/edit-location/' + id);
                        } else if (subUrl[5] == 'location' && subUrl[6] == 'add-location') {
                          subModPath.push('information/orgInfo/location/add-location');
                        } else {
                          subModPath.push('information/orgInfo/location/view-location');
                        }
                      } else if (subModKeys[m] == 'Global Settings') {
                        if (subUrl[5] == 'global-settings' && subUrl[6] == 'booking-day-configuration') {
                          subModPath.push('information/orgInfo/global-settings/booking-day-configuration');
                        }
                        else if (subUrl[5] == 'global-settings' && subUrl[6] == 'openbooking-status') {
                          subModPath.push('information/orgInfo/global-settings/openbooking-status')
                        }
                        else {
                          subModPath.push('information/orgInfo/global-settings/mail-configuration');
                        }
                      } else if (subModKeys[m] == 'Users') {
                        if (subUrl[5] == 'users' && subUrl[6] == 'single-view-users') {
                          subModPath.push('information/orgInfo/users/single-view-users/' + id);
                        } else if (subUrl[5] == 'users' && subUrl[6] == 'edit-users') {
                          subModPath.push('information/orgInfo/users/edit-users/' + id);
                        } else if (subUrl[5] == 'users' && subUrl[6] == 'add-users') {
                          subModPath.push('information/orgInfo/users/add-users');
                        } else {
                          subModPath.push('information/orgInfo/users/view-users');
                        }
                      } else if (subModKeys[m] == 'Geofence') {
                        if (subUrl[5] == 'geofence' && subUrl[6] == 'edit-geofence') {
                          subModPath.push('information/orgInfo/geofence/edit-geofence/' + id);
                        } else if (subUrl[5] == 'geofence' && subUrl[6] == 'add-geofence') {
                          subModPath.push('information/orgInfo/geofence/add-geofence');
                        } else {
                          subModPath.push('information/orgInfo/geofence/view-geofence');
                        }
                      } else if (subModKeys[m] == 'Geo Location') {
                        if (subUrl[5] == 'geolocation' && subUrl[6] == 'edit-geolocation') {
                          subModPath.push('information/orgInfo/geolocation/edit-geolocation/' + id);
                        } else if (subUrl[5] == 'geolocation' && subUrl[6] == 'add-geolocation') {
                          subModPath.push('information/orgInfo/geolocation/add-geolocation');
                        } else {
                          subModPath.push('information/orgInfo/geolocation/view-geolocation');
                        }
                      }
                      avlSubMod.push(subModKeys[m]);
                    }
                  }
                  if (actvSubMod != '') {
                    let subModIndex = avlSubMod.findIndex(e => e == actvSubMod);
                    if (subModIndex != -1) {
                      path.push(subModPath[subModIndex]);
                    } else {
                      path.push('information/orgInfo');
                    }
                  } else {
                    let url = this.findPath(this.router.url);
                    path.push(url);
                  }
                } else {
                  path.push('information');
                }
              } else {
                let url = this.findPath(this.router.url);
                path.push(url);
              }
            }
          } else {
            path.push('information');
          }
        } else if (menus[i] == 'Support Desk') {
          activeMenu.push('support-desk');
          if (activeModule == 'Support Desk') {
            let activeUrl = this.router.url.split('/');
            let activeSupportModule = '';
            if (activeUrl[3] == 'support-desk' && activeUrl[4] == 'announcement') {
              activeSupportModule = 'Announcement';
            } else if (activeUrl[3] == 'support-desk' && activeUrl[4] == 'complaint' && (activeUrl[5] == 'view-complaint' || activeUrl[5] == 'action-complaint')) {
              activeSupportModule = 'Complaints';
            } else if (activeUrl[3] == 'support-desk' && activeUrl[4] == 'feedback') {
              activeSupportModule = 'Feedback';
            } else if (activeUrl[3] == 'support-desk' && activeUrl[4] == 'ticket') {
              activeSupportModule = 'Ticket';
            } else {
              let url = this.findPath(this.router.url);
              path.push(url);
            }
            let keys = Object.keys(this.userRestrictionData['Support Desk'].menu1);
            let availableModules = [];
            let availablePath = [];
            for (let i = 0; i < keys.length; i++) {
              if (this.userRestrictionData['Support Desk'].menu1[keys[i]].checked || this.userRestrictionData['Support Desk'].menu1[keys[i]].indeterminate) {
                if (keys[i] == 'Announcement') {
                  availablePath.push('support-desk/announcement');
                } else if (keys[i] == 'Complaints') {
                  let subUrl = this.router.url.split('/');
                  if (subUrl[5] == 'action-complaint') {
                    let id = subUrl[6];
                    availablePath.push('support-desk/complaint/action-complaint/' + id);
                  } else {
                    availablePath.push('support-desk/complaint/view-complaint');
                  }
                } else if (keys[i] == 'Feedback') {
                  availablePath.push('support-desk/feedback');
                } else if (keys[i] == 'Ticket') {
                  availablePath.push('support-desk/ticket');
                }
                availableModules.push(keys[i]);
              }
            }
            let index = availableModules.findIndex(e => e == activeSupportModule);
            if (index != -1) {
              path.push(availablePath[index]);
            } else {
              path.push('support-desk');
            }
          } else {
            path.push('support-desk');
          }
        }
      }
    }
    let index = activeMenu.findIndex(e => e == url[3]);
    if (index != -1) {
      await this.router.navigate(['/organization/transport-manager/' + path[index]]);
    } else {
      await this.router.navigate(['/organization/transport-manager/' + path[0]]);
    }
  }
  findPath(url) {
    let y = url.split('/');
    let z = y.slice(3);
    let a = z.join('/');
    return a;
  }
  getUserData() {
    if (this.userInfo) {
      if (this.userInfo['mappingField'])
        this.mappingField = this.userInfo['mappingField'];
      this.listenGenericSubService();
      this.getOSRMUrl();
      this.createTopMenu();
    } else {
      this.api.GetCurUserOrg({}).then((res: any) => {
        if (res.status == 'success') {
          this.userInfo = res.data[0];
          if (this.userInfo['mappingField']) this.mappingField = this.userInfo['mappingField'];
          this.storage.setData({ userInfo: this.userInfo });

          this.listenGenericSubService();
          this.getOSRMUrl();
          this.createTopMenu();
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  listenGenericSubService() {

    if (this.storage.get('notificationData-' + this.userInfo['orgID'])) {

      this.notificationData = this.storage.get('notificationData-' + this.userInfo['orgID']);
    }
    this.notificationState.listen().subscribe((data) => {
      let getReqOnly = data.filter((item: any) => item['type'] == 'REQUEST');
      if (getReqOnly.length > 0) this.isNewRequest = true;
      this.dynamicObj['requests'] = getReqOnly;

      let getSOSOnly = data.filter((item: any) => item['type'] == 'SOS');
      if (getSOSOnly.length > 0) this.isNewSos = true;
      this.dynamicObj['sos'] = getSOSOnly;

      let getoverSpeedOnly = data.filter((item: any) => item['type'] == 'Overspeed');
      if (getoverSpeedOnly.length > 0) this.isNewSos = true;
      this.dynamicObj['overSpeed'] = getoverSpeedOnly;
      // this.notifCountSync();
      // this.shakeIconClass = "shake-icon";
      // setTimeout(() => {
      //   if (this.storage.get('audioPlay')) {
      //     this.AlertNotification();
      //     this.storage.setData(({ 'audioPlay': false }))
      //   }
      //   this.shakeIconClass = "";
      // }, 10 * 1000);
    })


    this.sub.listen.subscribe((data: any) => {
      if (data && data['for'] == "notification-channel") {
        let notificationIndex = this.notificationData.findIndex((item) => item.type == data['payload']['type'] && item['id'] == data['payload']['id']);
        if (notificationIndex == -1) {
          this.notificationData.unshift({
            type: data['payload']['type'],
            message: data['payload']['message'],
            id: data['payload']['id'],
          });
          // let getReqOnly = this.notificationData.filter((item:any)=> item['type'] == 'REQUEST' )
          // this.dynamicObj['requests'] = getReqOnly;
          // let getSOSOnly = this.notificationData.filter((item:any)=> item['type'] == 'SOS' )
          // this.dynamicObj['sos'] = getSOSOnly;

          this.notifCountSync();
          this.shakeIconClass = "shake-icon";
          setTimeout(() => {
            if (this.storage.get('audioPlay')) {
              this.AlertNotification();
              this.storage.setData(({ 'audioPlay': false }))
            }
            this.shakeIconClass = "";
          }, 10 * 1000);
        }
      }
    })
  }

  AlertNotification() {

    var audio = new Audio('./assets/mp3/Notification/notif-audio-1.wav');

    audio.play();
  }

  notifCountSync() {
    this.notificationMenu = this.notificationMenu.map((notif: any) => {
      // console.log(notif);
      notif['count'] = this.notificationData.filter(x => notif['label'] == x['type']).length;
      return notif;
    });

    // console.log( this.notificationData );
    this.notificationData.slice(0, 100);

    let temp = {};
    temp['notificationData-' + this.userInfo['orgID']] = this.notificationData;

    this.storage.setData(temp);


    // notificationData

  }

  removeAllNotifData() {
    this.notificationData = [];
    this.notifCountSync();
    this.notificationState.removeAllNotifications()
  }
  removeNotifData(id) {
    this.notificationState.removerNofit(id)
    // let reqIndex = this.dynamicObj['requests'].findIndex((data)=> data['id'] == id)
    // if(reqIndex != -1){
    //   let x=this.dynamicObj['requests'].splice(reqIndex,1);
    //   // this.dynamicObj['requests'] = this.dynamicObj['requests'].splice(reqIndex,1)
    // }

    // let sosIndex = this.dynamicObj['sos'].findIndex((data)=> data['id'] == id) 
    // if(sosIndex != -1){
    //   this.dynamicObj['sos'] = this.dynamicObj['sos'].splice(sosIndex,1)
    // }
    // this.notificationData = this.notificationData.filter(x => x['id'] != id);
    this.notifCountSync();
  }
  async findAvailableTopMenus() {
    return new Promise((resolve, reject) => {
      let user = this.storage.get('userInfo');
      this.userRestrictionData = user['fieldMap'];
      let menus = Object.keys(this.userRestrictionData || {});
      let menuList = [];
      for (let i = 0; i < menus.length; i++) {
        if (this.userRestrictionData[menus[i]].checked || this.userRestrictionData[menus[i]].indeterminate) {
          menuList.push(menus[i]);
        }
      }
      this.currentTab = menuList[0];
      let data = [];
      for (let j = 0; j < menuList.length; j++) {
        for (let k = 0; k < this.availableTopMenus.length; k++) {
          if (menuList[j] == this.availableTopMenus[k]['label']) {
            if (this.availableTopMenus[k]['label'] == 'Route / Rostering') {
              let activSubModuleInRostering = [];
              let subModulesOfRostering = Object.keys(this.userRestrictionData['Route / Rostering'].menu1);
              for (let i = 0; i < subModulesOfRostering.length; i++) {
                if (this.userRestrictionData && (this.userRestrictionData['Route / Rostering'].checked || this.userRestrictionData['Route / Rostering'].indeterminate) && this.userRestrictionData['Route / Rostering'].menu1 && this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]] && (this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].checked || this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].indeterminate)) {
                  activSubModuleInRostering.push(subModulesOfRostering[i]);
                }
              }
              if (activSubModuleInRostering[0] == 'Activities') {
                this.availableTopMenus[k]['path'] = '/organization/transport-manager/rostering';
              } else if (activSubModuleInRostering[0] == 'Manage') {
                this.availableTopMenus[k]['path'] = '/organization/transport-manager/rostering/manage-route';
              } else if (activSubModuleInRostering[0] == 'Regular') {
                this.availableTopMenus[k]['path'] = '/organization/transport-manager/rostering/create-route/regular';
              } else if (activSubModuleInRostering[0] == 'Occasional') {
                this.availableTopMenus[k]['path'] = '/organization/transport-manager/rostering/create-route/occasional';
              } else if (activSubModuleInRostering[0] == 'Open Booking') {
                this.availableTopMenus[k]['path'] = '/organization/transport-manager/rostering/create-route/openBooking';
              }
            }
            data.push(this.availableTopMenus[k]);
          }
        }
      }
      resolve(data);
    })

  }
  topMenuSetup() {
    const url = this.router.url.split('/');
    if (url && url[1] === 'master') {
      this.empsUser = 'master';
      this.topMenu = this.masterMenu;
    }
    if (url && url[2] === 'transport-manager') {
      this.empsUser = 'transport-manager';
      this.topMenu = this.tpmDashboardMenu;
    }
    if (url && url[2] === 'vendor') {
      this.empsUser = 'vendor';
      this.topMenu = this.vendorMenu;
    }
    this.currentPath = this.router.url;
    this.defaultCircle(this.topMenu, this.currentPath);
  }



  listenRouting() {
    let routerUrl: string, routerList: Array<any>, target: any;
    this._router.events.subscribe((router: any) => {
      routerUrl = router.urlAfterRedirects;
      if (routerUrl && typeof routerUrl === 'string') {
        target = this.menu;
        this.breadcrumbList.length = 0;
        routerList = routerUrl.slice(1).split('/');
        routerList.forEach((router, index) => {
          if (target != undefined) {
            target = target.find(page => page.path.slice(1) === router);
            if (target != undefined) {
              this.breadcrumbList.push({
                name: target.name,
                path:
                  index === 0
                    ? target.path
                    : `${this.breadcrumbList[index - 1].path}/${target.path.slice(
                      1
                    )}`
              });
            }

            if (index + 1 !== routerList.length && target) {
              target = target.children;
              // console.log('target --> ', target)
            }
          }
          if (routerList.length == index + 1) {
            // console.log('Bread C', this.breadcrumbList);

          }
        });

      }
    });
  }


  getLable(t) {
    this.storage.setData({ tabValue: t });
    // console.log(t, this.selected)
  }
  toggleSideBar() {
    this.tiggleSideBar.emit('over');
    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }


  getOSRMUrl() {
    if (this.userInfo['osrm'] == undefined) {
      this.api.empsOsrmUrl({}).then((res: any) => {
        if (res.status == 'success') {
          this.osrmUrl = { ...res };
          delete this.osrmUrl['status'];
          this.storage.setData({ 'userInfo': { ...this.userInfo, 'osrm': this.osrmUrl } })
          this.shared._subject.next({
            type: 'osrm_url',
            data: this.osrmUrl,
          })
        }
      }).catch((err) => {
        console.log(err);
      });
    } else {
      this.shared._subject.next({
        type: 'osrm_url',
        data: this.userInfo['osrm'],
      })
    }

  }
  // getProfile() {
  //   console.log(this.profile.get)
  //   if (this.profile.get == null) {
  //     this.profile.listen.subscribe((value) => {
  //       this.userInfo = value;
  //       console.log(this.userInfo)
  //     })
  //   } else {
  //     this.userInfo = this.profile.get;
  //   }
  //   console.log("profile state", this.userInfo)
  // }

  logOut() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be sign out.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, I am sure!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.signOut();
      }
    });
  }
  signOut() {

    const urlPathArr = this.getUrl.split('/');
    if (urlPathArr && urlPathArr[1] === 'master') {
      this.shared._subject.next({
        type: 'navBar',
        isShowNavbar: true

      });
      this.router.navigate([`/${urlPathArr[1]}/login`]);
      localStorage.clear();
      this.storage.removeAll();
      this.socketStore.setState([]);
    }

    if (urlPathArr && urlPathArr[2] === 'vendor' || urlPathArr[2] === 'transport-manager') {
      this.shared._subject.next({
        type: 'navBar',
        isShowNavbar: true

      });
      this.router.navigate([`/organization/${urlPathArr[2]}/login`]);

      localStorage.clear();
      this.storage.removeAll();
      this.socketStore.setState([]);
    }
  }
  // Moving Dashboard Menu circleIcon
  changeCirclePos(value: number) {
    this.mousePos = value;
  }
  async currentPage(tabIndex: number) {
    this.currentTab = this.topMenu[tabIndex].label;
    this.currentPath = this.topMenu[tabIndex].path;
    this.getLable(tabIndex);
    this.mousePos = tabIndex;
  }
  findActiveSubModuleInRostering() {
    return new Promise((res, rej) => {
      let subModulesOfRostering = Object.keys(this.userRestrictionData['Route / Rostering'].menu1);
      for (let i = 0; i < subModulesOfRostering.length; i++) {
        if (this.userRestrictionData && (this.userRestrictionData['Route / Rostering'].checked || this.userRestrictionData['Route / Rostering'].indeterminate) && this.userRestrictionData['Route / Rostering'].menu1 && this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]] && (this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].checked || this.userRestrictionData['Route / Rostering'].menu1[subModulesOfRostering[i]].indeterminate)) {
          res(subModulesOfRostering[i]);
        }
      }
    })
  }
  // Default Dashboard Menu circleIcon
  defaultCirclePos() {
    this.currentPath = this.router.url;
    this.defaultCircle(this.topMenu, this.currentPath);
    this.mousePos = this.dot;
  }
  defaultCircle(obj, value) {
    this.dot = Object.keys(obj).find((key) => value.includes(obj[key].path));
    if (this.dot) {
      this.currentTab = obj[this.dot].label;
      this.mousePos = this.dot;
    }
  }

  close(notificationId) {
    this.alertNotifications = this.alertNotifications.filter((alert) => alert.notificationID != notificationId);
  }
  openNotification() {
    let notificationBtn = document.getElementById('notificationDropdown');
    notificationBtn.click();
    this.isNotificationOpen = true;
    this.notificationTooltip = false;
    // this.getNotificationData('sos','SOS');
    this.tabChange({ index: this.actvNotifyIndex });
  }
  closeNotification() {
    let notificationBtn = document.getElementById('notificationDropdown');
    notificationBtn.click();
    this.isNotificationOpen = false;
    this.notificationTooltip = true;
  }
  checkNotificationOpen() {
    // console.log(this.isNotificationOpen);
    if (this.isNotificationOpen) this.closeNotification();
  }
  selectAllNotification(type, event) {
    // console.log(type, event);
  }
  public noNotification: boolean = false;
  public isNewSos: boolean = false;
  public isNewRequest: boolean = false;
  public isNewComplaint: boolean = false;
  public actvNotifyIndex: number = 0;
  tabChange(e) {
    console.log("e", e)
    let index = e.index;
    this.actvNotifyIndex = index;
    let menu = this.notificationMenu[index];
    this.selectedMod = menu['key'];
    if (this.selectedMod == 'sos') {
      this.activeNotifyModule = 'SOS Notifications';
      this.isNewSos = false;
      if (this.dynamicObj && this.dynamicObj['sos'] && this.dynamicObj['sos'].length > 0) {
        let arrLength = this.dynamicObj['sos'].length;
        for (let i = 0; i < arrLength; i++) {
          this.removeNotifData(this.dynamicObj['sos'][0]['id']);
        }
      }
    } else if (this.selectedMod == 'overSpeed') {
      this.activeNotifyModule = 'Over Speed Notifications';
      this.isNewSos = false;
      if (this.dynamicObj && this.dynamicObj['overSpeed'] && this.dynamicObj['overSpeed'].length > 0) {
        let arrLength = this.dynamicObj['overSpeed'].length;
        for (let i = 0; i < arrLength; i++) {
          this.removeNotifData(this.dynamicObj['overSpeed'][0]['id']);
        }
      }
    } else if (this.selectedMod == 'vehicleInfo') {
      this.activeNotifyModule = 'Vehicle Info Notifications';
    } else if (this.selectedMod == 'breakdown') {
      this.activeNotifyModule = 'Breakdown Notifications';
    } else if (this.selectedMod == 'request') {
      this.isNewRequest = false;
      this.activeNotifyModule = 'Request Notifications';
      if (this.dynamicObj && this.dynamicObj['requests'] && this.dynamicObj['requests'].length > 0) {
        let arrLength = this.dynamicObj['requests'].length;
        for (let i = 0; i < arrLength; i++) {
          this.removeNotifData(this.dynamicObj['requests'][0]['id']);
        }
      }
    } else if (this.selectedMod == 'complaints') {
      this.isNewComplaint = false;
      this.activeNotifyModule = 'Complaint Notifications';
    }

    if (this.selectedMod == 'sos' || this.selectedMod == 'request' || this.selectedMod == 'complaints' || this.selectedMod == 'breakdown' || this.selectedMod == 'overSpeed') {
      this.getNotificationData(menu['key'], menu['label']);
    } else {
      this.notificationData = [];
      this.noNotification = true;
    }
  }
  async getNotificationData(key, type) {
    if (key != '') {
      let obj = {
        'type': key
      }
      this.api.getNotificationData(obj).then((res: any) => {
        if (res.status == 'success') {
          if (res['data'] && res['data'][key] && res['data'][key].length > 0) {
            let response = res['data'][key][0];
            if (response != undefined && response && response.length > 0) {
              this.noNotification = false;
              for (let i = 0; i < response.length; i++) {
                // console.log(response[i])
                if (this.selectedMod == 'sos') {
                  this.activeNotifyModule = 'SOS Notifications';
                  response[i]['message'] = 'SOS from ' + response[i]['regNo'] + ' at ' + new Date(response[i]['time']).toLocaleDateString('en-GB') + ' ' + this.comservice.convertTime(response[i]['time']);
                } else if (this.selectedMod == 'overSpeed') {
                  this.activeNotifyModule = 'Over Speed Notifications';
                  // TN10TE1001 is running at 70 km/h at 15:38.
                  response[i]['message'] = response[i]['regNo'] + ' is running at' + ' ' + response[i]['speed'] + ' km/h as of ' + new Date(response[i]['time']).toLocaleDateString('en-GB') + ' ' + this.comservice.convertTime(response[i]['time']);
                } else if (this.selectedMod == 'vehicleInfo') {
                  this.activeNotifyModule = 'Vehicle Info Notifications';
                } else if (this.selectedMod == 'breakdown') {
                  this.activeNotifyModule = 'Breakdown Notifications';
                  // this.notificationData.filter((item:any)=>{
                  //   console.log("this.comservice.timestampToDate(item,'DMY')",this.comservice.timestampToDate(item.time,'DMY H:M A'))
                  //   item.time = this.comservice.timestampToDate(item.time,'DMY H:M A')
                  // }) 
                  response[i].time = this.comservice.timestampToDate(response[i].time, 'DMY H:M A')
                } else if (this.selectedMod == 'request') {
                  this.activeNotifyModule = 'Request Notifications';
                  let request = 'Request';
                  if (response[i]['reqType'] == 'route_request') {
                    request = 'Route request';
                  } else if (response[i]['reqType'] == 'address_update') {
                    request = 'Address update request';
                  } else if (response[i]['reqType'] == 'route_cancel') {
                    request = 'Route cancel request';
                  } else if (response[i]['reqType'] == 'shift_change') {
                    request = 'Shift change request';
                  } else if (response[i]['reqType'] == 'location_request') {
                    request = 'Location request';
                  } else if (response[i]['reqType'] == 'route_change') {
                    request = 'Route change request';
                  } else if (response[i]['reqType'] == 'leave_request') {
                    request = 'Leave request';
                  } else {
                    request = 'Request';
                  }
                  response[i]['message'] = request + ' from ' + this.firstLetterCapitalize(response[i]['empName']) + ' at ' + new Date(response[i]['time']).toLocaleDateString('en-GB') + ' ' + this.comservice.convertTime(response[i]['time']);
                } else if (this.selectedMod == 'complaints') {
                  this.activeNotifyModule = 'Complaint Notifications';
                  response[i]['message'] = 'Complaint from ' + this.firstLetterCapitalize(response[i]['name']) + ' at ' + new Date(response[i]['time']).toLocaleDateString('en-GB') + ' ' + this.comservice.convertTime(response[i]['time']);
                }
              }
              this.notificationData = response;
            } else {
              this.notificationData = [];
              this.noNotification = true;
            }
          } else {
            this.notificationData = [];
            this.noNotification = true;
          }
        } else {
          this.notificationData = [];
          this.noNotification = true;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  firstLetterCapitalize(str: string) {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }
  async viewNotification(id, type?) {
    let path = '';
    if (this.selectedMod == 'sos') {
      this.isNewSos = false;
      if (this.dynamicObj && this.dynamicObj['sos'] && this.dynamicObj['sos'].length > 0) {
        let arrLength = this.dynamicObj['sos'].length;
        for (let i = 0; i < arrLength; i++) {
          this.removeNotifData(this.dynamicObj['sos'][0]['id']);
        }
      }
      path = 'organization/transport-manager/sospanel/map-view';
      let url = this.router.url.split('/');
      if (url && url[4] != 'map-view') {
        this.storage.setData({ sosID: id });
        await this.comservice.sleep(10);
        this.router.navigate([path]);
      } else {
        this.shared._subject.next({
          type: 'sosID',
          data: id,
        })
        this.checkNotificationOpen();
      }
    } else if (this.selectedMod == 'complaints') {
      this.isNewComplaint = false;
      path = 'organization/transport-manager/support-desk/complaint/action-complaint/'
      this.router.navigate(['organization/transport-manager/support-desk/complaint/view-complaint']);
      await this.comservice.sleep(10);
      this.router.navigate([path + id]);
    } else if (this.selectedMod == 'request') {
      this.isNewRequest = false;
      if (this.dynamicObj && this.dynamicObj['requests'] && this.dynamicObj['requests'].length > 0) {
        let arrLength = this.dynamicObj['requests'].length;
        for (let i = 0; i < arrLength; i++) {
          this.removeNotifData(this.dynamicObj['requests'][0]['id']);
        }
      }
      let request = '';
      if (type == 'route_request') {
        request = 'route-request/';
      } else if (type == 'address_update') {
        request = 'address-update/';
      } else if (type == 'route_cancel') {
        request = 'route-cancel/';
      } else if (type == 'shift_change') {
        request = 'shift-change/';
      } else if (type == 'location_request') {
        request = 'location-request/';
      } else if (type == 'route_change') {
        request = 'route-change/';
      } else if (type == 'leave_request') {
        request = 'leave-request/';
      }
      path = 'organization/transport-manager/request/list-request/';
      this.router.navigate([path]);
      await this.comservice.sleep(10);
      this.router.navigate([path + request]);
    }
  }

  navigateToSOS() {
    this.router.navigate(['organization/transport-manager/reports/overspeed-reports'], {
      queryParams: {
        param1: 'overspeed-alerts',
      }
    });
  }
}
